import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { Navbar } from './Navbar'
import { Footer } from './Footer'
import { FreeToolsStrip } from './FreeToolsStrip'
import { ErrorBoundary } from '@/components/ui/ErrorBoundary'

export default function RootLayout() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1" id="main-content" style={{ paddingTop: 'var(--header-height)' }}>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <FreeToolsStrip />
      <Footer />
    </div>
  )
}
